import { useEffect } from 'react';
import { autoUploadUnsubs } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { SUBSCRIPTION_ANALYTICS } from 'reactApp/sections/MobileSubscriptionsPage/MobileSubscription.analytics';
import { sendDwh, sendXray } from 'reactApp/utils/ga';

import type { DwhData } from '../CancelAutoRenewalModal.types';

export const useSendAnalyticAfterOpen = (dwhData: DwhData) => {
    // TODO: заменить на `useFirstEffect`
    // Возможно, стоит переименовать `useFirstEffect` в `useEffectOnce`
    useEffect(() => {
        if (autoUploadUnsubs) {
            sendXray('autoupload_cancel_touch_show');
        }
        sendDwh({
            ...SUBSCRIPTION_ANALYTICS.MY_TARIFF_CANCEL_STEP0_OPEN,
            dwhData,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
